/* eslint-disable react/prop-types */
import { Flexbox, Form, Mask } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'

// import { Container } from './styles';

function TutorForm({ touched, setFieldValue, errors }) {
  return (
    <>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.documentNumber && errors?.documentNumber ? 'has-error' : ''}`}>
          <Form.Label htmlFor="documentNumber">Documento <span className="text-error">*</span></Form.Label>
          <Form.ValidationField name="documentNumber">
            {
              ({ field }) => (
                <Mask.CpfCnpj
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  placeholder="CPF/CNPJ do tutor"
                  id="documentNumber"
                  onAccept={(value) => {
                    setFieldValue('documentNumber', value)
                  }}
                />
              )
            }
          </Form.ValidationField>
          {
            touched?.documentNumber && errors?.documentNumber
              ? <Form.Hint className="text-error">{errors.documentNumber}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-8 col-sm-12">
        <Form.Group className={`${touched?.fullName && errors?.fullName ? 'has-error' : ''}`}>
          <Form.Label htmlFor="fullName">Nome do beneficiário <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="fullName"
            id="fullName"
            placeholder="Fulano da Silva"
          />
          {
            touched?.fullName && errors?.fullName
              ? <Form.Hint className="text-error">{errors.fullName}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-6 col-sm-12">
        <Form.Group className={`${touched?.email && errors?.email ? 'has-error' : ''}`}>
          <Form.Label htmlFor="email">E-mail <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="email"
            id="email"
            placeholder="fulano@email.com"
            type="email"
          />
          {
            touched?.email && errors?.email
              ? <Form.Hint className="text-error">{errors.email}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-6 col-sm-12">
        <Form.Group className={`${touched?.phoneNumber && errors?.phoneNumber ? 'has-error' : ''}`}>
          <Form.Label htmlFor="phoneNumber">Telefone <span className="text-error">*</span></Form.Label>
          <Form.ValidationField name="phoneNumber">
            {
              ({ field }) => (
                <Mask.Phone
                  id="phoneNumber"
                  placeholder="(00) 99999-9999"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  onAccept={(v) => setFieldValue('phoneNumber', v)}
                />
              )
            }
          </Form.ValidationField>
        </Form.Group>
      </Flexbox.Column>
    </>
  )
}

TutorForm.defaultProps = {
  touched: PropTypes.objectOf(Object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(Object).isRequired,
}

export default TutorForm
